import { render, staticRenderFns } from "./cadbairros.vue?vue&type=template&id=1168a667&"
import script from "./cadbairros.vue?vue&type=script&lang=js&"
export * from "./cadbairros.vue?vue&type=script&lang=js&"
import style0 from "./cadbairros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports